import React from 'react';

const BellNotificationSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M19.142 17.958h.97v1.004h-5.541a2.518 2.518 0 0 1-2.515 2.488 2.519 2.519 0 0 1-2.516-2.488H4v-1.004h.954l-.028-5.85c0-4.478 2.778-7.769 6.667-7.99V3h-1.541V2h4.001v1h-1.46V4.13c3.812.3 6.52 3.562 6.52 7.977l.029 5.852zm-8.602 1.004a1.518 1.518 0 0 0 1.516 1.488c.826 0 1.5-.665 1.515-1.488h-3.03zm1.473-13.856c-3.527 0-6.087 2.944-6.087 7l.028 5.814h12.188l-.03-5.812c0-4.058-2.564-7.002-6.1-7.002z"
            fillRule="evenodd"
        />
    </svg>
);

BellNotificationSvg.displayName = 'BellNotificationSvg';
export default BellNotificationSvg;
